import React, { useState } from "react";
import { Button, Menu, Dropdown, Tooltip } from "antd";
import { useSelector } from "react-redux";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import "../styles/components/floatingButton.scss";

export default function FloatingButton() {
  const [visible, setVisible] = useState(true);

  const allBusinesses = useSelector((state) => state.business.businessList);

  // Filter only activated businesses for security
  const businesses = allBusinesses.filter(
    (business) => business.activated === 1
  );

  const manageBusiness = (id) => {
    // Security check: ensure the business is activated before allowing access
    const business = allBusinesses.find(
      (b) => b.id.toString() === id.toString()
    );

    if (!business || business.activated !== 1) {
      console.warn("Access denied: Business not activated or not found");
      return;
    }

    localStorage.setItem("editBusiness", id);
    window.location.replace("/business");
  };

  const menu = (
    <Menu>
      {businesses.map((business) => (
        <Menu.Item
          key={business.url}
          onClick={() => manageBusiness(`${business.id}`)}
        >
          {business.name}
        </Menu.Item>
      ))}
    </Menu>
  );

  // Only show the floating button if there are businesses
  if (!businesses || businesses.length === 0) {
    return null;
  }

  return (
    <div className={`floating-button ${visible ? "" : "hidden"}`}>
      <Tooltip title="My Businesses" placement="left">
        <Dropdown overlay={menu} trigger={["click"]} placement="topLeft">
          <Button type="primary" size="large">
            <FontAwesomeIcon icon="fa-solid fa-briefcase" />
          </Button>
        </Dropdown>
      </Tooltip>

      <Button
        className="toggle-button"
        shape="circle"
        size="small"
        onClick={() => setVisible(!visible)}
      >
        {visible ? "−" : "+"}
      </Button>
    </div>
  );
}
